import React, { useMemo, memo } from 'react';
import { RuleBuilderInput } from '..';
import RuleInputForm from '../rule-input-form/RuleInputForm';
import { ReportField } from '../../../../models/reportField';
import { noop } from '../../../../util';
import RuleInfo from '../rule-info/RuleInfo';

interface RuleListProps {
  reportField: ReportField;
  rules: RuleBuilderInput[];
  onRemoveRuleClick?: (rule: RuleBuilderInput) => void;
  onEditRuleClick?: (rule: RuleBuilderInput) => void;
  onRuleChange?: (rule: RuleBuilderInput) => void;
}

function RuleList({
  reportField,
  rules,
  onRemoveRuleClick,
  onEditRuleClick,
  onRuleChange,
}: RuleListProps): JSX.Element {
  const renderedRules = useMemo(
    () =>
      rules.map((rule, index) => {
        const removeRuleHandler = (): void => {
          onRemoveRuleClick(rule);
        };
        const editRuleHandler = (): void => {
          onEditRuleClick(rule);
        };
        return rule.isEditing ? (
          <RuleInputForm
            key={rule.id}
            reportField={reportField}
            rule={rule}
            hasLogicalRule={index > 0}
            onRemoveClick={removeRuleHandler}
            onChange={onRuleChange}
          />
        ) : (
          <RuleInfo
            key={rule.id}
            reportField={reportField}
            rule={rule}
            hasLogicalRule={index > 0}
            onRemoveClick={removeRuleHandler}
            onEditClick={editRuleHandler}
            onRuleChange={onRuleChange}
          />
        );
      }),
    [onEditRuleClick, onRemoveRuleClick, onRuleChange, reportField, rules],
  );

  return <div>{rules && renderedRules}</div>;
}

RuleList.defaultProps = {
  onRemoveRuleClick: noop,
  onRuleChange: noop,
};

export default memo(RuleList);
